<template>
  <div>
    <template v-if="show">
        <v-breadcrumbs :items="items" class="pt-2 pb-0 mb-n2">
          <template v-slot:divider>
            <v-icon>mdi-forward</v-icon>
          </template>
          <v-breadcrumbs-item
              slot="item"
              slot-scope="{ item }"
              ripple
              :href="item.href"
              :disabled="item.disabled"
              :class="item.class"
              :style="item.style"
              >
              <span @click="gotoRoute(item.name)">{{ item.text }}</span>
          </v-breadcrumbs-item>    
        </v-breadcrumbs>
    </template>
  </div>
</template>

<script>
import { AppColor } from '@/config.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppBreadcrumbs',
  data() {
    return {
      appColor_Background: AppColor.Background,
      appColor_HyperLink: AppColor.Breadcrumb
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'isAdmin',
      'routeStack',
      'currentRoute']),
    items () {
      return this.routeStack.map(rs => { return {
        text: this.getFriendlyName(rs),
        name: rs,
        disabled: rs === this.currentRoute,
        style: rs !== this.currentRoute
          ? 'cursor: pointer; color: ' + this.appColor_HyperLink
          : '',
        class: rs !== this.currentRoute
          ? this.hyperLinkClass
          : this.labelClass
      }})
    },
    show () {
      return this.routeStackCount > 1
    },
    routeStackCount () {
      if (this.routeStack === null) return 0
      return this.routeStack.length
    },
    hyperLinkClass () {
      if (this.isSmallDevice) return 'caption'
      else if (this.$vuetify.breakpoint.name === 'sm') return 'body-1'
      return 'subtitle-1'
    },
    labelClass () {
      if (this.isSmallDevice) return 'caption'
      else if (this.$vuetify.breakpoint.name === 'sm') return 'body-1'
      return 'subtitle-1'
    }
  },
  methods: {
    ...mapActions(['popRoute']),
    getFriendlyName (route) {
      if (route === 'Home') return this.getExpression('Breadcrumb', 'Home')
      else if (route === 'ResidentDashboard') return this.getExpression('Breadcrumb', 'ResidentDashboard')
      else if (route === 'KioskDashboard') return this.getExpression('Breadcrumb', 'KioskDashboard')
      else if (route === 'AdminDashboard') return 'Admin Dashboard'
      else if (route === 'ResidentManager') return 'Residents'
      else if (route === 'AdminUserManager') return 'Users'
      else if (route === 'KioskManager') return 'Kiosks'
      else if (route === 'FacilityManager') return 'Facilities'
      else if (route === 'DomainManager') return 'Domains'
      else if (route === 'OrganizationManager') return 'Organizations'

      // genie
      else if (route === 'MessageManager') return 'Messages'
      else if (route === 'ResidentMediaManager') return this.getExpression('Breadcrumb', 'ResidentLibrary')
      else if (route === 'ResidentMetrics') return this.getExpression('Breadcrumb', 'ResidentMetrics')
      else if (route === 'KioskMediaManager') return this.getExpression('Breadcrumb', 'KioskLibrary')
      else if (route === 'ResidentPlaylistManager') return this.getExpression('Breadcrumb', 'MemoryAlbums')
      else if (route === 'KioskPlaylistManager') return this.getExpression('Breadcrumb', 'CommunityPlaylists')
      else if (route === 'KioskEmailManager') return this.getExpression('Breadcrumb', 'KioskEmails')
      else if (route === 'PublicMediaManager') return 'Genie Public Library'
      else if (route === 'ConfigManager') return 'Button Configs'
      else if (route === 'GenieKioskManagers') return this.getExpression('Breadcrumb', 'KioskManagers')
      else if (route === 'GenieKioskResidentContacts') return this.getExpression('Breadcrumb', 'ResidentContacts')
      else if (route === 'GenieResidentContacts') return this.getExpression('Breadcrumb', 'ResidentContacts')
      else if (route === 'GenieManualManager') return 'Manuals'
      else if (route === 'GeniePromotionalMediaManager') return 'Promotional Media'
      else if (route === 'MessagePurges') return 'Message Purges'
      else if (route === 'UserEvents') return 'User Events'
      else if (route === 'ResidentEvents') return 'Resident Events'
      else if (route === 'KioskEvents') return 'Kiosk Events'
      else if (route === 'PlaylistEvents') return 'Playlist Events'
      else if (route === 'AbbyUpdateZipManager') return 'Abby Update Zips'

      // abby
      else if (route === 'AbbyResidentProfileManager') return this.getExpression('Breadcrumb', 'ResidentPlaylists')
      else if (route === 'AbbyKioskProfileManager') return this.getExpression('Breadcrumb', 'KioskPlaylists')
      else if (route === 'AbbyActivityManager') return 'Abby Activities'
      else if (route === 'AbbyAmbientInvitationManager') return 'Ambient Invitations'
      else if (route === 'AbbyExpressionManager') return 'Abby Expressions'
      else if (route === 'AbbySharedLibraryManager') return 'Abby Shared Library'
      else if (route === 'AbbyKioskParticpants') return this.getExpression('Breadcrumb', 'PlatformParticipants')
      else if (route === 'AbbyResidentFacilitators') return this.getExpression('Breadcrumb', 'Facilitators')
      else if (route === 'KioskKeyTagMapper') return 'Kiosk Key/Tag Mappings'

      // temporary (for daniel)
      else if (route === 'UpdateOverrideAbbys') return 'Update Override Abbys'

      // cira stats
      // else if (route === 'CiraStats') return 'HSPP Stats'

      else return route
    },

    gotoRoute (name) {
      if (name == this.currentRoute) return
      this.$store.dispatch('setRoute', { name })
      this.$router.push({ name: name })
    }
  }
}
</script>
